import { SettingsLayout } from '@agentic-flow-studio/shared/components/settings/SettingsLayout';
import type { SettingsNavItem } from '@agentic-flow-studio/shared/components/settings/SettingsSidebar';
import { Stethoscope, Zap } from 'lucide-react';
import { pushDriver } from '@/lib/push';
import { authClient, getBetterAuthToken } from '@/utils/betterAuth';

const clinicNavItems: SettingsNavItem[] = [
  {
    id: 'clinic',
    label: 'Clinic Settings',
    icon: Stethoscope,
    to: 'clinic',
    description: 'Categories, mail tags & domain weights',
  },
  {
    id: 'rules',
    label: 'Automation Rules',
    icon: Zap,
    to: 'rules',
    description: 'Auto-replies & triage automation rules',
  },
];

export default function Settings() {
  return (
    <SettingsLayout
      productKey="inbox_clinic"
      productLabel="Inbox.clinic"
      pushDriver={pushDriver}
      connectAccounts={{
        providers: { gmail: true, outlook: true },
        portal: 'clinic',
      }}
      customNavItems={clinicNavItems}
      getAuthToken={getBetterAuthToken}
      authClient={authClient}
      showDiagnostics={import.meta.env.DEV}
    />
  );
}
